import React from 'react';
import PropTypes from 'prop-types';
import Article from '@prisjakt/ui-article';
import { bemGenerator } from '@prisjakt/ui-base';
import CardList from '../card-list';
import CampaignGroup from '../../areas/campaign/components/campaign-group';

import './index.scss';

const styles = bemGenerator('featured-article', ['related']);

const FeaturedArticle = ({ article, related, embedded }) => {
  const articleId = article ? article.id : null;
  const relatedArticles = (article &&
  article.related &&
  article.related.articles
    ? related.concat(article.related.articles)
    : related
  )
    .filter(item => item.id !== articleId)
    .sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt));
  return (
    <section
      className={styles.block.withModifier({
        'hide-divider': relatedArticles.length === 0,
      })}
    >
      {!!article && <Article {...article} embedded={embedded} />}
      <section
        className={styles.related.withModifier({ 'full-width': !article })}
      >
        <CardList
          styling={article ? 'vertical' : 'horizontal'}
          items={relatedArticles}
        />
        {article && article.related && article.related.campaign && (
          <CampaignGroup campaigns={[article.related.campaign]} />
        )}
      </section>
    </section>
  );
};

const { object, shape, arrayOf, bool } = PropTypes;

FeaturedArticle.propTypes = {
  article: shape({
    related: shape({
      articles: arrayOf(object),
    }),
  }).isRequired,
  related: arrayOf(object),
  embedded: bool,
};

FeaturedArticle.defaultProps = {
  related: [],
  embedded: true,
};

export default FeaturedArticle;
